import { useStudentLogonAccess } from "../../api/getStudentLogonAccess";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  CircularProgress,
  Container,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import moment from "moment";
import { useStudentEvaluationsAndAttempts } from "../../api/getStudentEvaluationsAndAttempts";
import CustomTable from "../../../../ui/components/Table";
import { useState } from "react";
import { AttemptAnswers } from "./AttemptAnswers";

const StudentEvaluationsAndAttempts = ({ enrollmentId }) => {
  const { data, isLoading } = useStudentEvaluationsAndAttempts({
    enrollmentId,
  });
  const [expandedRow, setExpandedRow] = useState(-1);
  if (isLoading) {
    return <CircularProgress />;
  }
  return (
    <Box>
      <CustomTable>
        <TableHead>
          <TableRow>
            <TableCell>
              <Typography>Nome do capítulo</Typography>
            </TableCell>
          </TableRow>
        </TableHead>

        {data?.map((evaluation, index) => {
          const isExpanded = expandedRow == index;
          const handleExpand = (row) => (event, newExpanded) => {
            setExpandedRow(newExpanded ? row : -1);
          };

          return (
            <Accordion
              disabled={!evaluation.surveyAttemptId}
              expanded={isExpanded}
              onChange={handleExpand(index)}
            >
              <AccordionSummary>
                <TableRow disableGutters key={evaluation.id}>
                  <Typography>
                    {evaluation.chapter +
                      (!evaluation.surveyAttemptId ? " (Sem tentativas)" : "")}
                  </Typography>
                  {/* <TableCell></TableCell> */}
                </TableRow>
              </AccordionSummary>
              <AccordionDetails>
                {isExpanded && (
                  <AttemptAnswers
                    enrollmentId={enrollmentId}
                    attemptId={evaluation.surveyAttemptId}
                  />
                )}
              </AccordionDetails>
            </Accordion>
          );
        })}
      </CustomTable>
    </Box>
  );
};

export { StudentEvaluationsAndAttempts };
